/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      // Process full text to convert escaped HTML to actual HTML
      if (this.fullText) {
        let fullTextContent = this.fullText.innerHTML;
        // Convert escaped HTML tags to actual HTML
        fullTextContent = fullTextContent.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        // Remove spaces between closing span tags and punctuation
        fullTextContent = fullTextContent.replace(/(<\/span>)\s+!/g, '$1!');
        this.fullText.innerHTML = fullTextContent;
      }
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          let formattedMoney = formatMoney(remaining, format);
          formattedMoney = formattedMoney.replace(/\.\d{2}$/, '');
          amount_text.innerHTML = formattedMoney;
        }
        this.remainingText.style.display = 'flex';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'flex';
      }

      this.style.setProperty('--percentage', percentage);

    }
  }
  customElements.define('free-shipping', FreeShipping);
}